import React, { useState, useEffect } from 'react';
import { Container, Button, Spinner } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import "./TagStyle.css";

const ApproveOrganization = () => {
  const { orgId } = useParams();
  const navigate = useNavigate();
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTags, setActiveTags] = useState([]);
  const [inactiveTags, setInactiveTags] = useState([]);

  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        const response = await fetch(`/api/admin/approveOrganization/${orgId}`);
        const data = await response.json();
        setOrganization(data);

        const inactive = data.tags.filter(tag => !tag.is_active);
        const active = data.tags.filter(tag => tag.is_active);

        setInactiveTags(inactive);
        setActiveTags(active);
      } catch (error) {
        console.error('Error fetching organization:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrganization();
  }, [orgId]);

  const toggleTagActivity = (tag, isActive) => {
    if (isActive) {
      // Move tag from Active to Inactive
      setActiveTags(prevActiveTags => prevActiveTags.filter(t => t.tag_id !== tag.tag_id));
      setInactiveTags(prevInactiveTags => [...prevInactiveTags, { ...tag, is_active: false }]);
    } else {
      // Move tag from Inactive to Active
      setInactiveTags(prevInactiveTags => prevInactiveTags.filter(t => t.tag_id !== tag.tag_id));
      setActiveTags(prevActiveTags => [...prevActiveTags, { ...tag, is_active: true }]);
    }
  };

  const handleApprove = async () => {
    try {
      const response = await fetch(`/api/admin/approveOrganization/${orgId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          activeTags: activeTags.map(tag => tag.tag_id),
          inactiveTags: inactiveTags.map(tag => tag.tag_id),
        }),
      });
  
      if (response.ok) {
        navigate('/admin');
      } else {
        console.error('Failed to approve organization.');
      }
    } catch (error) {
      console.error('Error approving organization:', error);
    }
  };
  

  return (
    <Container>
      {loading ? (
        <Spinner animation="border" />
      ) : organization ? (
        <>
          <h3 className="text-center mb-4 mt-4">{organization.org_name}</h3>
          <p><strong>Branch:</strong> {organization.branch}</p>
          <p><strong>Website:</strong> <a href={organization.org_url} target="_blank" rel="noopener noreferrer">{organization.org_url}</a></p>
          <p><strong>Database URL:</strong> {organization.db_url}</p>
          <p><strong>Contact Person:</strong> {organization.contact_person}</p>
          <p><strong>Contact Person Role:</strong> {organization.contact_person_role}</p>
          <p><strong>Contact Email:</strong> {organization.contact_email}</p>
          <p><strong>Contact Phone:</strong> {organization.contact_phone}</p>
          <p><strong>Summary:</strong> {organization.org_summary}</p>
          <p><strong>For-Profit:</strong> {organization.for_profit ? 'Yes' : 'No'}</p>

          <h5>Active Tags:</h5>
          {activeTags.length > 0 ? (
            <ul className="d-flex flex-wrap list-unstyled mt-2">
              {activeTags.map(tag => (
                <li
                  key={tag.tag_id}
                  className="tag-style clickable-tag"
                  onClick={() => toggleTagActivity(tag, true)}
                >
                  <span className="me-2">{tag.tag_name}</span>
                  <span className="tag-toggle-symbol ms-2"></span>
                </li>
              ))}
            </ul>
          ) : (
            <p>No active tags assigned to this organization.</p>
          )}

          <h5 className="mt-4">Inactive Tags:</h5>
          {inactiveTags.length > 0 ? (
            <ul className="d-flex flex-wrap list-unstyled mt-2">
              {inactiveTags.map(tag => (
                <li
                  key={tag.tag_id}
                  className="tag-style tag-inactive clickable-tag"
                  onClick={() => toggleTagActivity(tag, false)}
                >
                  <span className="me-2">{tag.tag_name}</span>
                  <span className="tag-toggle-symbol ms-2"></span>
                </li>
              ))}
            </ul>
          ) : (
            <p>No inactive tags assigned to this organization.</p>
          )}

          <Button variant="success" onClick={handleApprove} className="mt-3">
            Approve Organization
          </Button>
        </>
      ) : (
        <p>Organization not found.</p>
      )}
    </Container>
  );
};

export default ApproveOrganization;
